<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex md12>
                <material-card>
                    <models-ponderables-table
                        :plataformas="plataformas"
                        :items="ponderables"
                        v-if="ponderables && plataformas"
                    ></models-ponderables-table>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Vue from "vue"
import { PonderablesService, PlataformaService } from "../../services/carreras-api.service"

export default Vue.extend({
    data: () => ({
        ponderables: [],
        plataformas: []
    }),
    methods: {
        fetchPonderables() {
            PonderablesService.where({ include: "ponderableGeneradores?" }).then(ponderables => {
                ponderables.forEach(ponderable => {
                    if (!ponderable.color) {
                        ponderable.color = "#000000"
                    }
                })
                this.ponderables = ponderables
            })
        },
        fetchPlataformas() {
            PlataformaService.where().then(plataformas => {
                this.plataformas = plataformas
            })
        }
    },
    created() {
        this.fetchPonderables()
        this.fetchPlataformas()
    }
})
</script>
